import request from '@/utils/request';

export function getUserSystem() {
  return request({
    url: '/system/userCommon/sys',
    method: 'get'
  })
}

export function getUserSystemAll() {
  return request({
    url: '/system/userCommon/allSys',
    method: 'get'
  })
}

export function getUserInfo() {
  return request({
    url: '/system/userCommon/info',
    method: 'get'
  })
}

// export function Menus() {
//   return request({
//     url: '/system/userCommon/menu',
//     method: 'get',
//     headers: { 'joineast-system-id': 2 }
//   })
// }
export function getCodeInfo() {
  return request({
    url: '/system/userCommon/code',
    method: 'get'
  })
}

export function getExceptionResolutionApi() {
  return request({
    url: '/order/fmCollectionCode/exception/resolution',
    method: 'get'
  })
}

export function getUserCount() {
  return request({
    url: '/system/common/gateway/statistics',
    method: 'get'
  })
}
